/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RateToggle {
    Standard = 0,
    Flat = 1,
    Both = 2,
}
